import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getAccessDeniedPath = () => urlHelper('/access-denied');
